import { inject } from '@angular/core';
import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalStorageService } from '../../shared/services/local-storage.service';

/**
 * Interceptor that attaches X-Guest-Cart-Id header to requests
 * Used for:
 * - Cart operations (GET/POST/PATCH/DELETE /api/v1/cart/*)
 * - Login/Register (to merge guest cart with user cart)
 */
export const guestCartInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  if (!shouldAttachGuestCartId(req)) {
    return next(req);
  }

  const localStorageService = inject(LocalStorageService);
  const guestCartId = localStorageService.getItem<string>('guest_cart_id');

  if (!guestCartId) {
    return next(req);
  }

  // Clone request and add X-Guest-Cart-Id header
  const cloned = req.clone({
    setHeaders: {
      'X-Guest-Cart-Id': guestCartId
    }
  });

  return next(cloned);
};

/**
 * Determine if guest cart ID should be attached
 * - Cart API endpoints: /api/v1/cart/*
 * - Auth endpoints (for merge): /api/v1/auth/login, /api/v1/auth/register
 */
function shouldAttachGuestCartId(req: HttpRequest<any>): boolean {
  const url = req.url;

  // Cart endpoints
  if (/\/api\/v1\/cart\b/.test(url)) {
    return true;
  }

  // Auth endpoints (login/register) for cart merge
  return /\/api\/v1\/auth\/(login|register)\b/.test(url);
}

